// extracted by mini-css-extract-plugin
export default {"content":"wakeApp_content_jVuGv","box":"wakeApp_box_jxajE","wakeBtn":"wakeApp_wakeBtn_9HeHa"};